export class LocationPortableInfo {
  isOnlyPortable?= false;
  useOnlyUnitsMarkedMobile?= false;
  hidePortableUnitsOnRatesPage?= false;
  deliveryFeeId?: string;
  redeliveryFeeId?: string;
  relocationFeeId?: string;
  moveInFeeId?: string;
  finalPickUpFeeId?: string;
  maxDeliveryDistance?: number;
  deliveryZipCodes?: string;
  dropOffOptions?: string[] = [];
  deliveryTimeOptions?: string[] = [];
};



// WEBPACK FOOTER //
// ./src/ng2/app/models/locationPortableInfo.ts